/*
 * Copyright (c) 2017 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducer from './rootReducer';

const immutableMiddleware = require('redux-immutable-state-invariant').default();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware = process.env.NODE_ENV !== 'production'
  ? [immutableMiddleware, thunk]
  : [thunk];

export const configureStore = (preloadedState = {}) => {
  return createStore(reducer, preloadedState, composeEnhancers(applyMiddleware(...middleware)));
};



// WEBPACK FOOTER //
// ./src/store.js